module.exports = __webpack_public_path__ + "static/media/Electronics.165090fc.jpg";